import { inject, Injectable } from '@angular/core';
import { AbcCore } from '@barthauer/abc/core';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import {
  AssetsManagerService,
  DependencyState,
} from 'libs/abc/core/assets-manager/src/lib/abc-core-assets-manager.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private coreService = inject(AbcCore);
  private configService = inject(AbcConfigService);
  private assetsService = inject(AssetsManagerService);

  constructor() {}

  loadPanoramo(): Promise<DependencyState[]> {
    return this.assetsService.loadDependencies(['assets/panoramo/index.js']);
  }

  queryPipeGraphics(
    view: string,
    pipeId: string,
    additionalId: string,
    tableIds: string[],
    settings: any,
    getMediaMaybe: boolean,
    isInitial: boolean,
  ): Observable<ArrayBuffer> {
    const parameters: any = {};
    parameters.view = view;
    parameters.idAbwLeitung = pipeId;
    parameters.additionalId = additionalId;
    parameters.tableIds = tableIds;
    parameters.settings = settings;
    parameters.getMediaMaybe = getMediaMaybe;
    parameters.isInitial = isInitial;

    return this.executeWebApiPOSTMethod('api/Extensions/WwPipeGraphics', parameters);
  }

  queryNodeGraphics(
    view: string,
    nodeId: string,
    nodeType: string | number,
    additionalId: string,
    tableIds: string[],
    settings: any,
    getMediaMaybe: boolean,
    isInitial: boolean,
  ): Observable<ArrayBuffer> {
    const parameters: any = {};
    parameters.view = view;
    parameters.idAbwKnoten = nodeId;
    parameters.objectTypeAbwKnoten = nodeType;
    parameters.additionalId = additionalId;
    parameters.tableIds = tableIds;
    parameters.settings = settings;
    parameters.getMediaMaybe = getMediaMaybe;
    parameters.isInitial = isInitial;

    return this.executeWebApiPOSTMethod('api/Extensions/WwNodeGraphics', parameters);
  }

  queryPipeReport(view: string, pipeId: string, additionalId: string, settings: any): Observable<Blob> {
    const parameters: any = {};
    parameters.view = view;
    parameters.idAbwLeitung = pipeId;
    parameters.additionalId = additionalId;
    parameters.settings = settings;

    return this.executeWebApiPOSTMethodBlob('api/Extensions/WwPipeGraphics/Report', parameters);
  }

  queryNodeReport(
    view: string,
    nodeId: string,
    nodeType: string | number,
    additionalId: string,
    settings: any,
  ): Observable<Blob> {
    const parameters: any = {};
    parameters.view = view;
    parameters.idAbwKnoten = nodeId;
    parameters.objectTypeAbwKnoten = nodeType;
    parameters.additionalId = additionalId;
    parameters.settings = settings;

    return this.executeWebApiPOSTMethodBlob('api/Extensions/WwNodeGraphics/Report', parameters);
  }

  queryPipePhotos(idAbwLeitungsinspektionstext: string, settings: any): Observable<ArrayBuffer> {
    const parameters: any = {};
    parameters.idAbwLeitungsinspektionstext = idAbwLeitungsinspektionstext;
    parameters.settings = settings;

    return this.executeWebApiPOSTMethod('api/Extensions/WwPipeGraphics/Photos', parameters);
  }

  queryNodePhotos(idAbwKnoteninspektionstext: string, settings: any): Observable<ArrayBuffer> {
    const parameters: any = {};
    parameters.idAbwKnoteninspektionstext = idAbwKnoteninspektionstext;
    parameters.settings = settings;

    return this.executeWebApiPOSTMethod('api/Extensions/WwNodeGraphics/Photos', parameters);
  }

  queryPipeVideo(
    idAbwLeitungsinspektion: string,
    idAbwLeitungsinspektionstext: string | undefined,
    settings: any,
  ): Observable<ArrayBuffer> {
    const parameters: any = {};
    parameters.idAbwLeitungsinspektion = idAbwLeitungsinspektion;
    parameters.idAbwLeitungsinspektionstext = idAbwLeitungsinspektionstext;
    parameters.settings = settings;

    return this.executeWebApiPOSTMethod('api/Extensions/WwPipeGraphics/Video', parameters);
  }

  queryNodeVideo(
    idAbwKnoteninspektion: string,
    idAbwKnoteninspektionstext: string | undefined,
    settings: any,
  ): Observable<ArrayBuffer> {
    const parameters: any = {};
    parameters.idAbwKnoteninspektion = idAbwKnoteninspektion;
    parameters.idAbwKnoteninspektionstext = idAbwKnoteninspektionstext;
    parameters.settings = settings;

    return this.executeWebApiPOSTMethod('api/Extensions/WwNodeGraphics/Video', parameters);
  }

  persistPipeSettings(view: string, additionalId: string, settings: any): Observable<ArrayBuffer> {
    const parameters: any = {};
    parameters.view = view;
    parameters.additionalId = additionalId;
    parameters.settings = settings;

    return this.executeWebApiPOSTMethod('api/Extensions/WwPipeGraphics/Settings', parameters);
  }

  persistNodeSettings(
    view: string,
    nodeType: string | number,
    additionalId: string,
    settings: any,
  ): Observable<ArrayBuffer> {
    const parameters: any = {};
    parameters.view = view;
    parameters.objectTypeAbwKnoten = nodeType;
    parameters.additionalId = additionalId;
    parameters.settings = settings;

    return this.executeWebApiPOSTMethod('api/Extensions/WwNodeGraphics/Settings', parameters);
  }

  private executeWebApiPOSTMethod(url: string, body: any): Observable<ArrayBuffer> {
    return this.coreService.data.executeWebApiPOSTMethod(
      this.concat(this.configService.configuration.WebApi.BaseURL, url),
      body,
      true,
    );
  }

  private executeWebApiPOSTMethodBlob(url: string, body: any): Observable<Blob> {
    return this.coreService.data.executeWebApiPOSTMethodBlob(
      this.concat(this.configService.configuration.WebApi.BaseURL, url),
      body,
      true,
    );
  }

  private concat(str1: string, str2: string): string {
    if (str1[str1.length - 1] === '/') {
      return str1 + str2;
    } else {
      return str1 + '/' + str2;
    }
  }
}
